import {create} from 'zustand/react'

// Тип состояния хранилища.
export interface FooterStoreType {
    // Данные:

    // Видимость футера.
    visible: boolean

    // API:

    // Задать видимость футера.
    setVisibility: (visible: boolean) => void
}

// Хранилище настроек футера.
export const useFooterStore = create<FooterStoreType>(
    set => ({
        visible: true,

        // API:

        setVisibility(visible: boolean): void {
            set({visible})
        },
    })
)
